import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7a186e16"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content title"
};
const _hoisted_2 = {
  class: "divider-example-vertical-container"
};
const _hoisted_3 = {
  class: "m-titleRt"
};
const _hoisted_4 = {
  class: "m-checkList",
  style: {
    "opacity": "1"
  }
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "主队", -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = {
  class: "divider-example-vertical-container"
};
import { ref } from 'vue';
import * as echarts from 'echarts';
import axios from 'axios';
import { count } from './calculation.js';
export default {
  __name: 'KLineView',
  setup(__props, {
    expose: __expose
  }) {
    const chartContainer1 = ref(null);
    const chartContainer2 = ref(null);
    const chartContainer3 = ref(null);
    const divStyle1 = ref('display: none;'); // 初始样式设置div为可见
    const divStyle2 = ref('display: none;'); // 初始样式设置div为可见
    const divStyle3 = ref('display: none;'); // 初始样式设置div为可见
    const isVisible = ref(false);
    const active = ref(1);
    const oddId = ref("");
    const title = ref('');
    const goalLine = ref("");
    const footBall = ref({
      host: '',
      handicap: "",
      guest: "",
      big: "",
      dw_HANDICAP: "",
      small: ""
    });
    const matchDateTime = ref("");
    const isActive1 = ref(true);
    const isActive2 = ref(false);
    const isActive3 = ref(true);
    const isActive4 = ref(false);
    const isActive5 = ref(false);
    const cId = ref('2');
    const type1 = ref(null);
    const status1 = ref(null);
    const matchId1 = ref(null);
    const show = async (id, matchId) => {
      isVisible.value = true;
      oddId.value = id;
      active.value = 1;
      matchId1.value = matchId;
      await getFixedBonusV1(matchId);
      await getMatchHeadV1(matchId);
      await getKLineList(id, "2", null, null, matchId);
    };
    // 关闭弹出框
    const close = () => {
      isVisible.value = false;
    };
    const getFixedBonusV1 = async matchId => {
      const response = await axios.get('https://webapi.sporttery.cn/gateway/uniform/football/getFixedBonusV1.qry?clientCode=3001&matchId=' + matchId);
      let data = response.data;
      if (data.success) {
        let oddsHistory = data.value.oddsHistory;
        title.value = oddsHistory.homeTeamAbbName + ' VS ' + oddsHistory.awayTeamAbbName;
        goalLine.value = oddsHistory.hhadList[0].goalLine;
        if (data.value.sectionsNo999 != '') {
          title.value = oddsHistory.homeTeamAbbName + ' ' + data.value.sectionsNo999 + ' ' + oddsHistory.awayTeamAbbName;
        }
      }
    };
    const getMatchHeadV1 = async matchId => {
      const response = await axios.get('https://webapi.sporttery.cn/gateway/uniform/football/getMatchHeadV1.qry?source=web&sportteryMatchId=' + matchId);
      let data = response.data;
      if (data.success) {
        matchDateTime.value = data.value.matchDateTime;
      }
    };
    const change = value => {
      let company = 3;
      if (value == 0) {
        company = 3;
      } else if (value == 1) {
        company = 2;
      } else if (value == 2) {
        company = 7;
      } else if (value == 3) {
        company = 9;
      } else if (value == 4) {
        company = 136;
      } else {
        company = 2;
      }
      divStyle1.value = 'display: none';
      divStyle2.value = 'display: none';
      footBall.value = {
        host: '',
        handicap: "",
        guest: "",
        big: "",
        dw_HANDICAP: "",
        small: ""
      };
      getKLineList(oddId.value, company, type1.value, status1.value, matchId1.value);
    };
    const getKLineList = async (id, companyId, type, status, matchId) => {
      const response = await axios.get('https://tuhaojie.asia/api-foot/matchGoalWater/getKLineList?id=' + matchId + '&company=' + companyId);
      let list = response.data;
      const response2 = await axios.get('https://tuhaojie.asia/api-foot/supportRateV1/getRate?matchId=' + matchId);
      let list2 = response2.data;
      // let data = [];
      // if (list != null) {
      //   const date1 = new Date(matchDateTime.value);
      //   const ms1 = date1.getTime();
      //   for (let i = 0; i < list.length; i++) {
      //     const date2 = new Date(list[i].currentDate);
      //     const ms2 = date2.getTime();
      //     if (ms1 > ms2) {
      //       data.push(list[i]);
      //     }
      //   }
      // }
      isActive1.value = true;
      isActive2.value = false;
      cId.value = companyId;
      type1.value = type;
      status1.value = status;
      footBallRate1(list.list1, type);
      footBallRate2(list.list2);
      //footBallRate3(list2, status);
    };
    const footBallRate1 = (data, type) => {
      try {
        if (data != null) {
          footBall.value = data[data.length - 1];
        }
        if (data != null && data[data.length - 1].handicap != null) {
          divStyle1.value = 'display: block';
          chartContainer1.value.display = 'block';
          let dataList = [];
          let seriesList = [];
          let lineList = [];
          let pan = data[data.length - 1].handicap;
          if (pan > 0 && type == null) {
            isActive1.value = false;
            isActive2.value = true;
          } else if (type != null) {
            pan = type;
            if (type > 0) {
              isActive1.value = false;
              isActive2.value = true;
            } else {
              isActive1.value = true;
              isActive2.value = false;
            }
          }
          let lastNum = null;
          let max = null;
          let min = null;
          let sum = count(data[data.length - 1].host, data[data.length - 1].guest, '+');
          let deNum = Math.ceil(count(sum, 2, '/') * 100) / 100;
          ;
          for (let i = 0; i < data.length; i++) {
            let num = pan <= 0 ? data[i].host : data[i].guest;
            max = max == null ? num : max < num ? num : max;
            min = min == null ? num : min > num ? num : min;
            const date = new Date(data[i].createTime);
            // 将字符串转换为 Date 对象
            let formattedDateTime = `${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`;
            dataList.push(formattedDateTime);
            if (lastNum == null) {
              seriesList.push([num, num, num, num, [data[i].host, data[i].handicap, data[i].guest]]);
              lastNum = num;
            } else {
              seriesList.push([lastNum, num, max, min, [data[i].host, data[i].handicap, data[i].guest]]);
              lastNum = num;
            }
            lineList.push([deNum, deNum, deNum, deNum]);
            max = null;
            min = null;
          }
          createKline(dataList, seriesList, lineList, chartContainer1.value, 1);
        }
      } catch (error) {
        // 处理错误
        console.error(error);
      }
    };
    const footBallRate2 = data => {
      try {
        if (data != null && data[data.length - 1].big != null) {
          divStyle2.value = 'display: block';
          chartContainer2.value.display = 'block';
          let dataList = [];
          let seriesList = [];
          let lineList = [];
          let lastNum = null;
          let max = null;
          let min = null;
          let sum = count(data[data.length - 1].big, data[data.length - 1].small, '+');
          let deNum = Math.ceil(count(sum, 2, '/') * 100) / 100;
          ;
          for (let i = 0; i < data.length; i++) {
            let num = data[i].big;
            max = max == null ? num : max < num ? num : max;
            min = min == null ? num : min > num ? num : min;
            // 将字符串转换为 Date 对象
            const date = new Date(data[i].createTime);
            let formattedDateTime = `${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`;
            dataList.push(formattedDateTime);
            if (lastNum == null) {
              seriesList.push([num, num, num, num, [data[i].big, data[i].dw_HANDICAP, data[i].small]]);
              lastNum = num;
            } else {
              seriesList.push([lastNum, num, max, min, [data[i].big, data[i].dw_HANDICAP, data[i].small]]);
              lastNum = num;
            }
            lineList.push([deNum, deNum, deNum, deNum]);
            max = null;
            min = null;
          }
          createKline(dataList, seriesList, lineList, chartContainer2.value, 2);
        }
      } catch (error) {
        // 处理错误
        console.error(error);
      }
    };
    const footBallRate3 = (data, type) => {
      try {
        if (data != null && data.length > 0) {
          divStyle3.value = 'display: block';
          chartContainer3.value.display = 'block';
          let dataList = [];
          let seriesList = [];
          let lineList = [];
          if (type == null) {
            isActive3.value = true;
            isActive4.value = false;
            isActive5.value = false;
          } else if (type != null) {
            if (type == 1) {
              isActive3.value = true;
              isActive4.value = false;
              isActive5.value = false;
            } else if (type == 2) {
              isActive3.value = false;
              isActive4.value = true;
              isActive5.value = false;
            } else {
              isActive3.value = false;
              isActive4.value = false;
              isActive5.value = true;
            }
          }
          let lastNum = null;
          let max = null;
          let min = null;
          let sum = 0;
          let size = 0;
          for (let i = 1; i < data.length; i++) {
            let num = type == 1 ? data[i].hmoney : type == 2 ? data[i].dmoney : data[i].amoney;
            if (i > 0) {
              num = type == 1 ? count(data[i].hmoney, data[i - 1].hmoney, '-') : type == 2 ? count(data[i].dmoney, data[i - 1].dmoney, '-') : count(data[i].amoney, data[i - 1].amoney, '-');
            }
            const date = new Date(data[i].dateString);
            // 将字符串转换为 Date 对象
            let formattedDateTime = `${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`;
            if (i > 0) {
              const date2 = new Date(data[i - 1].dateString);
              let formattedDateTime2 = `${date2.getMonth() + 1}-${date2.getDate()} ${date2.getHours()}:${date2.getMinutes()}`;
              if (formattedDateTime == formattedDateTime2) {
                continue;
              }
            }
            size++;
            sum = count(num, sum, '+');
          }
          let deNum = Math.ceil(count(sum, size, '/') * 100) / 100;
          for (let i = 0; i < data.length; i++) {
            let num = type == 1 ? data[i].hmoney : type == 2 ? data[i].dmoney : data[i].amoney;
            if (i > 0) {
              num = type == 1 ? count(data[i].hmoney, data[i - 1].hmoney, '-') : type == 2 ? count(data[i].dmoney, data[i - 1].dmoney, '-') : count(data[i].amoney, data[i - 1].amoney, '-');
            }
            max = max == null ? num : max < num ? num : max;
            min = min == null ? num : min > num ? num : min;
            const date = new Date(data[i].dateString);
            // 将字符串转换为 Date 对象
            let formattedDateTime = `${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`;
            if (i > 0) {
              const date2 = new Date(data[i - 1].dateString);
              let formattedDateTime2 = `${date2.getMonth() + 1}-${date2.getDate()} ${date2.getHours()}:${date2.getMinutes()}`;
              if (formattedDateTime == formattedDateTime2) {
                continue;
              }
            }
            dataList.push(formattedDateTime);
            if (lastNum == null) {
              if (i > 0) {
                seriesList.push([num, num, num, num, [count(data[i].hmoney, data[i - 1].hmoney, '-'), count(data[i].dmoney, data[i - 1].dmoney, '-'), count(data[i].amoney, data[i - 1].amoney, '-')]]);
              } else {
                seriesList.push([num, num, num, num, [data[i].hmoney, data[i].dmoney, data[i].amoney]]);
              }
              lastNum = num;
            } else {
              if (i > 0) {
                seriesList.push([lastNum, num, max, min, [count(data[i].hmoney, data[i - 1].hmoney, '-'), count(data[i].dmoney, data[i - 1].dmoney, '-'), count(data[i].amoney, data[i - 1].amoney, '-')]]);
              } else {
                seriesList.push([lastNum, num, max, min, [data[i].hmoney, data[i].dmoney, data[i].amoney]]);
              }
              lastNum = num;
            }
            lineList.push([deNum, deNum, deNum, deNum]);
            max = null;
            min = null;
          }
          createKline(dataList, seriesList, lineList, chartContainer3.value, 3);
        }
      } catch (error) {
        // 处理错误
        console.error(error);
      }
    };
    const createKline = (xDatas, sDatas, lineList, chartContainer, type) => {
      const chart = echarts.init(chartContainer);
      var stickColor = ['#4CAF50', '#FF3344'];
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            animation: false,
            axisPointer: {
              lineStyle: {
                type: 'solid',
                color: '#b2b5c1'
              }
            }
          },
          textStyle: {
            fontSize: '.24rem'
          },
          hideDelay: 0,
          padding: 5,
          formatter: function (params) {
            var time = params[0].name;
            var kd = params[0].data;
            var rate = (kd[2] - kd[1]) / kd[1] * 100;
            rate = rate > 0 ? '+' + rate.toFixed(2) : rate.toFixed(2);
            var html = "";
            if (type == 1) {
              html = `${time}<br>主：${kd[5][0]} <br>盘：${kd[5][1]}<br>客：${kd[5][2]} <br><span class='rate'>涨跌：${rate}%</span><br>`;
            } else if (type == 2) {
              html = `${time}<br>大：${kd[5][0]} <br>盘：${kd[5][1]}<br>小：${kd[5][2]} <br><span class='rate'>涨跌：${rate}%</span><br>`;
            } else {
              html = `${time}<br>胜：${kd[5][0]} <br>平：${kd[5][1]}<br>负：${kd[5][2]} <br><span class='rate'>涨跌：${rate}%</span><br>`;
            }
            return html;
          }.bind(this)
        },
        grid: {
          left: '10%',
          right: '3%',
          bottom: '8%'
        },
        legend: {
          icon: 'roundRect',
          orient: 'horizontal',
          top: '2%',
          right: '15%',
          itemWidth: 35,
          itemHeight: 9,
          itemGap: 100
          // textStyle: {
          //     color: '#FFFFFF'
          // }
        },
        xAxis: [{
          type: 'category',
          data: xDatas,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false //不显示刻度
          },
          boundaryGap: true,
          axisPointer: {
            //轴指示器
            type: 'shadow',
            z: 1,
            shadowStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(18,155,249,0)' // 0% 处的颜色
                }, {
                  offset: 1,
                  color: 'rgba(18,155,249,1)' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              },
              shadowColor: 'rgba(0, 0, 0, 0.2)',
              shadowBlur: 5
            }
          }
        }],
        yAxis: [{
          type: 'value',
          scale: true,
          axisLabel: {
            show: true
          },
          splitLine: {
            show: true
          },
          axisTick: {
            show: false //不显示刻度
          },
          axisLine: {
            show: false
          },
          nameTextStyle: {
            color: "#FFFFFF"
          },
          splitArea: {
            show: false
          }
        }],
        dataZoom: [{
          type: 'inside',
          startValue: xDatas.length > 100 ? xDatas.length - 100 : 0,
          endValue: xDatas.length - 1
        }],
        series: [{
          name: 'k线',
          type: 'candlestick',
          data: sDatas,
          itemStyle: {
            normal: {
              color: stickColor[1],
              color0: stickColor[0],
              borderColor: stickColor[1],
              borderColor0: stickColor[0]
            }
          }
        }, {
          name: '中位线',
          type: 'candlestick',
          // 中线系列
          data: lineList,
          itemStyle: {
            color: '#7aa4fa',
            // 设置上涨线的颜色为蓝色
            color0: '#7aa4fa',
            // 如果需要，‌也可以设置下跌线的颜色（‌这里保持为红色，‌但你可以根据需要修改）‌
            borderColor: '#7aa4fa',
            // 设置上涨线边框的颜色（‌如果需要边框的话）‌
            borderColor0: '#7aa4fa' // 设置下跌线边框的颜色（‌同上）‌
          }
        }]
      };
      chart.setOption(option);
    };

    // 暴露给外部使用的函数
    __expose({
      show,
      close
    });
    return (_ctx, _cache) => {
      const _component_nut_col = _resolveComponent("nut-col");
      const _component_nut_row = _resolveComponent("nut-row");
      const _component_var_tab = _resolveComponent("var-tab");
      const _component_var_tabs = _resolveComponent("var-tabs");
      const _component_nut_divider = _resolveComponent("nut-divider");
      const _component_var_divider = _resolveComponent("var-divider");
      const _component_nut_popup = _resolveComponent("nut-popup");
      return _openBlock(), _createBlock(_component_nut_popup, {
        visible: isVisible.value,
        "onUpdate:visible": _cache[3] || (_cache[3] = $event => isVisible.value = $event),
        closeable: "",
        style: {
          padding: '30px 0px',
          height: '85%',
          width: '90%',
          overflow: 'auto'
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_nut_row, null, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, "(" + _toDisplayString(goalLine.value) + ")" + _toDisplayString(title.value), 1)]),
            _: 1
          })]),
          _: 1
        })]), _createVNode(_component_var_tabs, {
          active: active.value,
          "onUpdate:active": _cache[0] || (_cache[0] = $event => active.value = $event),
          onChange: change
        }, {
          default: _withCtx(() => [_createVNode(_component_var_tab, null, {
            default: _withCtx(() => [_createTextVNode("皇冠")]),
            _: 1
          }), _createVNode(_component_var_tab, null, {
            default: _withCtx(() => [_createTextVNode("365")]),
            _: 1
          }), _createVNode(_component_var_tab, null, {
            default: _withCtx(() => [_createTextVNode("澳门")]),
            _: 1
          }), _createVNode(_component_var_tab, null, {
            default: _withCtx(() => [_createTextVNode("威廉希尔")]),
            _: 1
          }), _createVNode(_component_var_tab, null, {
            default: _withCtx(() => [_createTextVNode("香港马会")]),
            _: 1
          })]),
          _: 1
        }, 8, ["active"]), _createVNode(_component_nut_divider, {
          "content-position": "left",
          style: {
            margin: '5px 0'
          }
        }, {
          default: _withCtx(() => [_createTextVNode("亚盘K线")]),
          _: 1
        }), _createElementVNode("div", null, [_createVNode(_component_nut_row, null, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(footBall.value.host), 1), _createVNode(_component_var_divider, {
              vertical: ""
            }), _createElementVNode("span", null, _toDisplayString(footBall.value.handicap), 1), _createVNode(_component_var_divider, {
              vertical: ""
            }), _createElementVNode("span", null, _toDisplayString(footBall.value.guest), 1)])]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
              class: _normalizeClass(["u-check", {
                active: isActive1.value
              }]),
              onClick: _cache[1] || (_cache[1] = $event => getKLineList(oddId.value, cId.value, -1, status1.value, matchId1.value))
            }, _hoisted_6, 2), _createElementVNode("div", {
              class: _normalizeClass(["u-check", {
                active: isActive2.value
              }]),
              onClick: _cache[2] || (_cache[2] = $event => getKLineList(oddId.value, cId.value, 1, status1.value, matchId1.value))
            }, "客队", 2)])])]),
            _: 1
          })]),
          _: 1
        })]), _createElementVNode("div", {
          ref_key: "chartContainer1",
          ref: chartContainer1,
          style: _normalizeStyle([{
            "width": "90vw",
            "height": "300px"
          }, divStyle1.value])
        }, null, 4), _createVNode(_component_nut_divider, {
          "content-position": "left"
        }, {
          default: _withCtx(() => [_createTextVNode("大小盘K线")]),
          _: 1
        }), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(footBall.value.big), 1), _createVNode(_component_var_divider, {
          vertical: ""
        }), _createElementVNode("span", null, _toDisplayString(footBall.value.dw_HANDICAP), 1), _createVNode(_component_var_divider, {
          vertical: ""
        }), _createElementVNode("span", null, _toDisplayString(footBall.value.small), 1)]), _createElementVNode("div", {
          ref_key: "chartContainer2",
          ref: chartContainer2,
          style: _normalizeStyle([{
            "width": "90vw",
            "height": "300px"
          }, divStyle2.value])
        }, null, 4)]),
        _: 1
      }, 8, ["visible"]);
    };
  }
};